import { Box, Typography } from '@mui/material';
import ModalTemplate from 'src/shared/templates/modalTemplate';
import { IDocument } from '@cyntler/react-doc-viewer';
import { useTranslation } from 'react-i18next';
import DocumentViewer from './documentViewer';

type DocumentViewerModalProps = {
  uri?: IDocument;
  modalOpen: boolean;
  onModalClose: () => void;
};
const DocumentViewerModal = (props: DocumentViewerModalProps) => {
  const { t } = useTranslation();
  const { modalOpen, onModalClose, uri } = props;

  // Kontrollera om filen är .xlsx eller .csv för att använda fullWidth
  const isExcelOrCsv =
    uri?.fileName?.toLowerCase().endsWith('.xlsx') ||
    uri?.fileName?.toLowerCase().endsWith('.csv');

  return (
    <ModalTemplate
      isOpen={modalOpen}
      onClose={() => onModalClose()}
      title={<Typography variant='h6'>{t('Live view')}</Typography>}
      content={
        <Box height='calc(80vh - 32px)'>
          <DocumentViewer documents={uri?.uri?.trim() ? [uri] : []} />
        </Box>
      }
      fullWidth={isExcelOrCsv}
    />
  );
};

export default DocumentViewerModal;

DocumentViewerModal.defaultProps = {
  uri: undefined,
};
